var _path, _g, _mask, _path2, _path3, _g2, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightImgPinShare56 = function SvgLightImgPinShare56(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 0h56v56H3z",
    opacity: 0.01
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31,
    cy: 44,
    fill: "#E0E0E0",
    rx: 6,
    ry: 2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#light_img_pin_share_56_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.01,
    fillRule: "evenodd",
    d: "M16.158 14.111c-6.122 0-11.084 4.962-11.084 11.083s4.962 11.084 11.083 11.084h9.846l3.112 4.977a1 1 0 0 0 1.696 0l3.112-4.977h9.846c6.12 0 11.083-4.962 11.083-11.084 0-6.12-4.962-11.083-11.083-11.083z",
    clipRule: "evenodd"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "light_img_pin_share_56_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 10C9.268 10 3 16.268 3 24s6.268 14 14 14h10.21l2.942 4.706a1 1 0 0 0 1.696 0L34.79 38H45c7.732 0 14-6.268 14-14s-6.268-14-14-14z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#09F",
    fillRule: "evenodd",
    d: "M17 10C9.268 10 3 16.268 3 24s6.268 14 14 14h10.21l2.942 4.706a1 1 0 0 0 1.696 0L34.79 38H45c7.732 0 14-6.268 14-14s-6.268-14-14-14z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0072BE",
    d: "m27.21 38 .848-.53a1 1 0 0 0-.848-.47zm2.942 4.706.848-.53zm1.696 0-.848-.53zM34.79 38v-1a1 1 0 0 0-.848.47zM4 24c0-7.18 5.82-13 13-13V9C8.716 9 2 15.716 2 24zm13 13C9.82 37 4 31.18 4 24H2c0 8.284 6.716 15 15 15zm10.21 0H17v2h10.21zM31 42.176l-2.942-4.706-1.696 1.06 2.942 4.706zm0 0-1.696 1.06a2 2 0 0 0 3.392 0zm2.942-4.706L31 42.176l1.696 1.06 2.942-4.706zM45 37H34.79v2H45zm13-13c0 7.18-5.82 13-13 13v2c8.284 0 15-6.716 15-15zM45 11c7.18 0 13 5.82 13 13h2c0-8.284-6.716-15-15-15zm-28 0h28V9H17z",
    mask: "url(#light_img_pin_share_56_svg__b)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#light_img_pin_share_56_svg__c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.93,
    cy: 24,
    r: 10.5,
    fill: "#fff",
    stroke: "#0072BE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09F",
    d: "M15.68 22.752c.234-.855.234-1.557.234-2.214v-.684h-5.742v.936h4.554c0 .549-.027 1.107-.216 1.845zm-2.664 4.131c-1.116 0-1.755-.225-1.755-.666 0-.45.639-.675 1.755-.675 1.125 0 1.764.225 1.764.675 0 .441-.64.666-1.764.666m0-2.232c-1.782 0-2.934.594-2.934 1.566 0 .963 1.152 1.557 2.934 1.557 1.79 0 2.943-.594 2.943-1.557 0-.972-1.152-1.566-2.943-1.566m.27-1.458v-1.449h-1.188v1.449H9.335v.936h7.46v-.936zm7.52-2.484c1.08 0 1.773.324 1.773.909 0 .594-.693.909-1.773.909-1.089 0-1.782-.315-1.782-.909 0-.585.693-.909 1.782-.909m0 2.763c1.764 0 2.997-.72 2.997-1.854 0-1.125-1.233-1.854-2.997-1.854-1.773 0-2.997.729-2.997 1.854 0 1.134 1.224 1.854 2.997 1.854m3.771.621h-7.506v.963h1.701v2.709h1.197v-2.709h1.665v2.709h1.206v-2.709h1.737z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M46.667 23.141v1.36h-1.392l-1.294 5.03h-1.504l-1.327-5.03h-1.504c-.42 1.633-.906 3.38-1.343 5.03h-1.52l-1.279-5.03H34v-1.36h1.18c-.323-1.31-.662-2.847-.97-4.141H35.7l.954 4.141h1.893L39.565 19h1.634l1.019 4.141h1.909c.323-1.326.647-2.814.97-4.141h1.505l-1.003 4.141zm-3.462 3.77.598-2.41H42.59c.21.873.372 1.487.615 2.41m-5.646-.017.647-2.394h-1.23zm2.427-3.753h.825c-.162-.614-.243-.873-.421-1.569-.13.534-.275 1.003-.404 1.57",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "light_img_pin_share_56_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.93 13h22v22h-22z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "light_img_pin_share_56_svg__a",
    width: 59.777,
    height: 37.614,
    x: 0.074,
    y: 11.111,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.313151 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_115_986"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_115_986",
    result: "shape"
  })))));
};
export default SvgLightImgPinShare56;